import { render } from "./Bookreview.vue?vue&type=template&id=6906e644&lang=pug"
import script from "./Bookreview.vue?vue&type=script&lang=ts"
export * from "./Bookreview.vue?vue&type=script&lang=ts"

import "./Bookreview.vue?vue&type=style&index=0&id=6906e644&lang=scss"
script.render = render

export default script